<ion-item class="color-option" lines="none">
    <ion-label>
        <span class="color-preview" [style.background]="PreviewColor"></span>
        {{ label }}
    </ion-label>
    <div slot="end" class="color-option-value color-toggle-target"
        tabindex="0"
        (click)="OnTogglePicker($event)"
        (keydown.enter)="OnTogglePicker($event)"
        (keydown.space)="OnTogglePicker($event)"
    >
        <span class="hex-prefix">#</span>
        <upp-kb-input [uppDataid]="dataid" class="color-value-input"
            [value]="HexValue"
            [placeholder]="placeholder"
            (Changed)="OnHexChanged($event)"
        ></upp-kb-input>
    </div>
</ion-item>
<div class="color-picker-panel" *ngIf="ShowPicker">
    <div class="color-picker-surface"
        [style.background-color]="PickerSurfaceColor"
        (pointerdown)="OnPickerSurfacePointerDown($event)"
        (pointermove)="OnPickerSurfacePointerMove($event)"
    >
        <span class="color-picker-surface-cursor"
            [style.left.%]="PickerCursorLeft"
            [style.top.%]="PickerCursorTop"
        ></span>
    </div>
    <div class="color-picker-hue-row">
        <input uppDataid="color-picker-hue-input" class="color-picker-hue-input" type="range" min="0" max="360"
            [value]="PickerHuePosition"
            (input)="OnPickerHueChanged($any($event.target).value)"
        />
    </div>
    <div class="color-picker-rgb">{{ RgbText }}</div>
</div>
